/**
 * Date absolue Europe/Paris — jour + heure (EPIC-029 / 29.5).
 * Plus de détail que `formatTimeAgo` ou `formatDate` (qui n'imposent
 * pas le fuseau horaire). Utilisé par la page dédiée `/activite` pour
 * afficher chaque événement avec une horodatation explicite et stable.
 *
 * @param {string} isoString - ISO 8601 (`DateTimeInterface::ATOM`).
 * @returns {string} Ex. "19/05/2026, 12:23". Chaîne vide si entrée invalide.
 */
export function formatAbsoluteDate(isoString) {
    if (!isoString) return "";

    try {
        const date = new Date(isoString);
        if (Number.isNaN(date.getTime())) return "";

        return new Intl.DateTimeFormat("fr-FR", {
            timeZone: "Europe/Paris",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        }).format(date);
    } catch {
        return "";
    }
}

/**
 * Date absolue Europe/Paris — jour + jour de la semaine court
 * (EPIC-030 / 30.5). Format : "01/05/2026 · ven.". Utilisé par la page
 * dédiée `/echeances` pour la colonne Date du tableau : la spec demande
 * une date sans horodatage mais avec un repère hebdomadaire pour aider
 * à la lecture chronologique.
 *
 * @param {string} isoString - ISO 8601 (`DateTimeInterface::ATOM`).
 * @returns {string} Ex. "01/05/2026 · ven.". Chaîne vide si entrée invalide.
 */
export function formatAbsoluteDateWithWeekday(isoString) {
    if (!isoString) return "";

    try {
        const date = new Date(isoString);
        if (Number.isNaN(date.getTime())) return "";

        const dmy = new Intl.DateTimeFormat("fr-FR", {
            timeZone: "Europe/Paris",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        }).format(date);
        const weekday = new Intl.DateTimeFormat("fr-FR", {
            timeZone: "Europe/Paris",
            weekday: "short",
        }).format(date);

        return `${dmy} · ${weekday}`;
    } catch {
        return "";
    }
}
